import { LegalStructure } from '../config/i18nConfig'
import { getI18NName } from '../components/Combobox/i18n/I18NCombobox'
import { useTranslation } from 'react-i18next'
import useGlobalContext from './useGlobalContext'
import { useMemo } from 'react'

type ReturnProps = {
    loaded: boolean
    legalStructures: LegalStructure[]
    getLegalStructure: (id: string) => LegalStructure
    getLegalStructureName: (id: string) => string
    getLegalStructureByName: (name: string) => LegalStructure
}

export default function useLegalStructures(): ReturnProps {
    const { i18n } = useTranslation()
    const { entities, loaded } = useGlobalContext('legalStructures')

    const legalStructures: LegalStructure[] = useMemo(
        () => entities?.sort((a, b) => (a.position || 1000) - (b.position || 1000)) || [],
        [entities],
    )

    const getLegalStructure = (id: string) => legalStructures.find(value => value.alpha === id)
    const getLegalStructureName = (id: string) =>
        getI18NName(
            legalStructures.find(value => value.alpha === id),
            i18n.language,
        )
    const getLegalStructureByName = (name: string) =>
        legalStructures.find(value =>
            value.names.some(i18nName => i18nName.value.toLowerCase().localeCompare(name.toLowerCase()) === 0),
        )

    return { loaded, legalStructures, getLegalStructure, getLegalStructureName, getLegalStructureByName }
}
